<div class="card p-0 m-0 shadow-none" *ngIf="file">
  <div class="card-header bg-transparent">
    <div class="row align-items-center">
      <div class="col">
        <h4 class="card-header-title m-0">Crop Image</h4>
      </div>
      <div class="col">
        <ngx-slider
          [(value)]="rotation"
          [options]="options"
          (userChangeEnd)="userChangeEnd($event)"></ngx-slider>
      </div>
      <div class="col-auto">
        <button (click)="keep.emit()" class="btn btn-primary">
          Keep the original
        </button>
      </div>
      <div class="col-auto">
        <button (click)="success()" class="btn btn-soft-primary">
          Crop image
        </button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="row">
      <div class="col-12">
        <div class="cropper-wrapper">
          <ng-container *ngIf="size">
            <ng-container *ngIf="size.width && size.height">
              <image-cropper
                [aspectRatio]="size.width / size.height"
                [canvasRotation]="canvasRotation"
                [(transform)]="transform"
                (imageCropped)="imageCropped($event)"
                format="jpeg"
                [maintainAspectRatio]="true"
                [imageFile]="file"></image-cropper>
            </ng-container>
            <ng-container *ngIf="size.aspectRatio">
              <image-cropper
                [canvasRotation]="canvasRotation"
                [(transform)]="transform"
                (imageCropped)="imageCropped($event)"
                format="jpeg"
                [imageFile]="file"
                [aspectRatio]="size.aspectRatio"></image-cropper>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!size">
            <image-cropper
              [canvasRotation]="canvasRotation"
              [(transform)]="transform"
              (imageCropped)="imageCropped($event)"
              format="jpeg"
              [maintainAspectRatio]="false"
              [imageFile]="file"></image-cropper>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
